import { Result } from 'entities/result'
import _ from 'lodash'
import { ReactNode } from 'react'
import { ResultInfoV2, ResultV2ViewModel, RiskData, RiskScore } from './result_v2_view_model'
import { Symptom } from 'components/send_history/result_v2'
import { Sample } from 'entities/sample'

export type ColorectalRiskScore = RiskScore & {
    colorectal_family_history: number
    ulcerative_colitis: number
    smoking: number
    alcohol: number
    exercise: number
    BMI: number
}
type ColorectalRiskRatio = ColorectalRiskScore

type ColorectalResultInfoV2 = ResultInfoV2 & {
    risk_score: ColorectalRiskScore
    risk_ratio: ColorectalRiskRatio
    risk_data: RiskData<ColorectalRiskScore>
}

export class ColorectalResultV2ViewModel extends ResultV2ViewModel {
    constructor(result: Result, sample: Sample) {
        super(result, '大腸がん', '1%程度', '3%程度', sample)
    }
    public info(): ColorectalResultInfoV2 {
        return super.info() as ColorectalResultInfoV2
    }

    private hasUlcerativeColitis = (): boolean => {
        return this.background.medicalHistories?.some((mh) => mh.disease === 'ulcerative_colitis') ?? false
    }

    public smoking = () => {
        if (this.background.smoking === 'now') {
            return '吸う'
        } else if (this.background.smoking === 'ever') {
            return 'やめた'
        } else {
            return '吸わない'
        }
    }

    public ulcerative_colitis = () => {
        return this.hasUlcerativeColitis() ? 'あり' : 'なし'
    }

    public colorectal_family_history = () => {
        const uniqCancers = _.uniq(this.background.familyHistories?.map((fh) => fh.cancer))
        if (uniqCancers.includes('colorectal')) {
            return '当てはまる'
        } else {
            return '該当なし'
        }
    }

    public alcohol = () => {
        if (this.background.alcoholPerWeek === 0) {
            return '飲まない'
        } else if (this.background.alcoholPerWeek === 0.5) {
            return '月に数日'
        } else {
            return `週に${this.background.alcoholPerWeek}日`
        }
    }

    public exercise = () => {
        if (this.background.exercise === 'unusual') {
            return '~週1回程度'
        } else if (this.background.exercise === 'sometimes') {
            return '週2-3回'
        } else {
            return `週4回以上`
        }
    }

    public symptomsView(symptoms: Symptom[]): ReactNode {
        return super.symptomsView(symptoms, 15)
    }

    public getHighTextPosition(): { top: number; right: number } {
        return { top: 2, right: 5 }
    }
}
